import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import BackArrowSvg from 'themes/components/steps/BackArrowSvg';
import FrontArrowSvg from 'themes/components/steps/FrontArrowSvg';
import { Tooltip as ReactTooltip } from "react-tooltip";
// import { uuid } from "core/utils";

function NikoFacilityOrderStatusBarTemplate({ nikoFacilityOrderStatusBarViewStore, children }) {
    const {
        pageViewStore,
        isStatusBarAllowed,
        getStatusButtonClassName,
        openPage,
        getUserAndDateCompleted,
        isBillingStepAllowed,
        changeStatusBarVisibility,
        isStatusBarVisible,
        areStepsDisabled,
        title
    } = nikoFacilityOrderStatusBarViewStore;
    // const id = uuid();
    return (
        <div>
            <div className="content__header u-flex--primary is-nested">
                <h2>
                    {title}
                </h2>
                {isStatusBarAllowed &&
                    <div onClick={() => changeStatusBarVisibility()} className='content__header__btn'><i className={` ${isStatusBarVisible ? 'u-rotate--180' : ''} u-icon u-icon--xsml u-icon--arrow-down--text`}></i></div>
                }
                <div className="u-flex--default u-mar--left--auto">
                    {children}
                </div>
                {isStatusBarAllowed && isStatusBarVisible &&
                    <div className='btn--progress__wrapper'>
                        <ReactTooltip
                            positionStrategy="fixed"
                            id={"registerTip"}
                            place="bottom"
                            render={({ activeAnchor }) => {
                                const html = activeAnchor?.getAttribute("data-tooltip-html");
                                return html ? <span dangerouslySetInnerHTML={{ __html: html }} /> : null;
                            }}
                        />
                        <button
                            className={`btn btn--new-progress ${getStatusButtonClassName("initial-intake")} is-first ${pageViewStore.page === 'initial-intake' ? 'is-active' : ''}`}
                            onClick={() => openPage("initial-intake")}
                            data-tooltip-html={`${getStatusButtonClassName("initial-intake") === "is-completed" ? getUserAndDateCompleted("initial-intake") : ""}`}
                            data-tooltip-id={"registerTip"}
                            disabled={areStepsDisabled}
                        >
                            <div className='btn--new-progress__back'>
                                <BackArrowSvg className={pageViewStore.page === 'initial-intake' ? 'is-active' : ''} status={getStatusButtonClassName("initial-intake")} />
                            </div>
                            <div className='btn--new-progress__btn'>
                                <i className="u-icon u-icon--sml btn--new-progress__icon"></i>
                                Initial intake
                            </div>
                            <div className='btn--new-progress__front'>
                                <FrontArrowSvg className={pageViewStore.page === 'initial-intake' ? 'is-active' : ''} status={getStatusButtonClassName("initial-intake")} />
                            </div>
                        </button>
                        <button
                            className={`btn btn--new-progress ${getStatusButtonClassName("insurance-review")} ${pageViewStore.page === 'insurance-review' ? 'is-active' : ''}`}
                            onClick={() => openPage("insurance-review")}
                            data-tooltip-html={`${getStatusButtonClassName("insurance-review") === "is-completed" ? getUserAndDateCompleted("insurance-review") : ""}`}
                            data-tooltip-id={"registerTip"}
                            disabled={areStepsDisabled}
                        >
                            <div className='btn--new-progress__back'>
                                <BackArrowSvg className={pageViewStore.page === 'insurance-review' ? 'is-active' : ''} status={getStatusButtonClassName("insurance-review")} />
                            </div>
                            <div className='btn--new-progress__btn'>
                                <i className="u-icon u-icon--sml btn--new-progress__icon"></i>
                                Insurance Review
                            </div>
                            <div className='btn--new-progress__front'>
                                <FrontArrowSvg className={pageViewStore.page === 'insurance-review' ? 'is-active' : ''} status={getStatusButtonClassName("insurance-review")} />
                            </div>
                        </button>
                        <button
                            className={`btn btn--new-progress ${getStatusButtonClassName("us-intake")} ${pageViewStore.page === 'us-intake' ? 'is-active' : ''}`}
                            onClick={() => openPage("us-intake")}
                            data-tooltip-html={`${getStatusButtonClassName("us-intake") === "is-completed" ? getUserAndDateCompleted("us-intake") : ""}`}
                            data-tooltip-id={"registerTip"}
                            disabled={areStepsDisabled}
                        >
                            <div className='btn--new-progress__back'>
                                <BackArrowSvg className={pageViewStore.page === 'us-intake' ? 'is-active' : ''} status={getStatusButtonClassName("us-intake")} />
                            </div>
                            <div className='btn--new-progress__btn'>
                                <i className="u-icon u-icon--sml btn--new-progress__icon"></i>
                                US Intake
                            </div>
                            <div className='btn--new-progress__front'>
                                <FrontArrowSvg className={pageViewStore.page === 'us-intake' ? 'is-active' : ''} status={getStatusButtonClassName("us-intake")} />
                            </div>
                        </button>
                        <button
                            className={`btn btn--new-progress ${getStatusButtonClassName("clinical-review")} ${pageViewStore.page === 'clinical-review' ? 'is-active' : ''}`}
                            onClick={() => openPage("clinical-review")}
                            data-tooltip-html={`${getStatusButtonClassName("clinical-review") === "is-completed" ? getUserAndDateCompleted("clinical-review") : ""}`}
                            data-tooltip-id={"registerTip"}
                            disabled={areStepsDisabled}
                        >
                            <div className='btn--new-progress__back'>
                                <BackArrowSvg className={pageViewStore.page === 'clinical-review' ? 'is-active' : ''} status={getStatusButtonClassName("clinical-review")} />
                            </div>
                            <div className='btn--new-progress__btn'>
                                <i className="u-icon u-icon--sml btn--new-progress__icon"></i>
                                Clinical Review
                            </div>
                            <div className='btn--new-progress__front'>
                                <FrontArrowSvg className={pageViewStore.page === 'clinical-review' ? 'is-active' : ''} status={getStatusButtonClassName("clinical-review")} />
                            </div>
                        </button>
                        {pageViewStore.isInventoryStepAllowed && 
                        <button
                            className={`btn btn--new-progress ${getStatusButtonClassName("inventory")} ${pageViewStore.page === 'inventory' ? 'is-active' : ''}`}
                            onClick={() => openPage("inventory")}
                            data-tooltip-html={`${getStatusButtonClassName("inventory") === "is-completed" ? getUserAndDateCompleted("inventory") : ""}`}
                            data-tooltip-id={"registerTip"}
                        >
                            <div className='btn--new-progress__back'>
                                <BackArrowSvg className={pageViewStore.page === 'inventory' ? 'is-active' : ''} status={getStatusButtonClassName("inventory")} />
                            </div>
                            <div className='btn--new-progress__btn'>
                                <i className="u-icon u-icon--sml btn--new-progress__icon"></i>
                                Inventory
                            </div>
                            <div className='btn--new-progress__front'>
                                <FrontArrowSvg className={pageViewStore.page === 'inventory' ? 'is-active' : ''} status={getStatusButtonClassName("inventory")} />
                            </div>
                        </button>
                        }
                        <button
                            className={`btn btn--new-progress ${getStatusButtonClassName("order-summary")} ${pageViewStore.page === 'order-summary' ? 'is-active' : ''}`}
                            onClick={() => openPage("order-summary")}
                            data-tooltip-html={`${getStatusButtonClassName("order-summary") === "is-completed" ? getUserAndDateCompleted("order-summary") : ""}`}
                            data-tooltip-id={"registerTip"}
                        >
                            <div className='btn--new-progress__back'>
                                <BackArrowSvg className={pageViewStore.page === 'order-summary' ? 'is-active' : ''} status={getStatusButtonClassName("order-summary")} />
                            </div>
                            <div className='btn--new-progress__btn'>
                                <i className="u-icon u-icon--sml btn--new-progress__icon"></i>
                                Order Summary
                            </div>
                            <div className='btn--new-progress__front'>
                                <FrontArrowSvg className={pageViewStore.page === 'order-summary' ? 'is-active' : ''} status={getStatusButtonClassName("order-summary")} />
                            </div>
                        </button>
                        {isBillingStepAllowed &&
                            <button
                                className={`btn btn--new-progress ${getStatusButtonClassName("billing")} is-last ${pageViewStore.page === 'billing' ? 'is-active' : ''}`}
                                onClick={() => openPage("billing")}
                                data-tooltip-html={`${getStatusButtonClassName("billing") === "is-completed" ? getUserAndDateCompleted("billing") : ""}`}
                                data-tooltip-id={"registerTip"}
                                disabled={areStepsDisabled}
                            >
                                <div className='btn--new-progress__back'>
                                    <BackArrowSvg className={pageViewStore.page === 'billing' ? 'is-active' : ''} status={getStatusButtonClassName("billing")} />
                                </div>
                                <div className='btn--new-progress__btn'>
                                    <i className="u-icon u-icon--sml btn--new-progress__icon"></i>
                                    Billing
                                </div>
                                <div className='btn--new-progress__front'>
                                    <FrontArrowSvg className={pageViewStore.page === 'billing' ? 'is-active' : ''} status={getStatusButtonClassName("billing")} />
                                </div>
                            </button>
                        }
                    </div>
                }
            </div>
        </div>
    )
}

NikoFacilityOrderStatusBarTemplate.propTypes = {
    nikoFacilityOrderStatusBarViewStore: PropTypes.object,
    children: PropTypes.any,
    t: PropTypes.func
};

export default defaultTemplate(NikoFacilityOrderStatusBarTemplate);
